"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJobLogEntityList = getJobLogEntityList;
exports.getJobName = getJobName;
exports.queryJobLogPage = queryJobLogPage;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function queryJobLogPage(query) {
  return (0, _requestPIM.default)({
    url: '/xyJobLog/page',
    method: 'get',
    params: query
  });
}
function getJobLogEntityList(data) {
  return (0, _requestPIM.default)({
    data: data,
    url: '/xyJobLog/getJobLogEntityList',
    method: 'post'
  });
}
function getJobName() {
  return (0, _requestPIM.default)({
    url: '/xyJobLog/getJobName',
    method: 'get'
  });
}